// tslint:disable
export var ContactInformationType;
(function (ContactInformationType) {
    // UNKN
    ContactInformationType[ContactInformationType["UNKN"] = 0] = "UNKN";
    // PHONE
    ContactInformationType[ContactInformationType["PHONE"] = 1] = "PHONE";
    // MOBILE
    ContactInformationType[ContactInformationType["MOBILE"] = 2] = "MOBILE";
    // FAX
    ContactInformationType[ContactInformationType["FAX"] = 3] = "FAX";
    // WEB
    ContactInformationType[ContactInformationType["WEB"] = 4] = "WEB";
    // E-MAIL
    ContactInformationType[ContactInformationType["EMAIL"] = 5] = "EMAIL";
    // DNC
    ContactInformationType[ContactInformationType["DNC"] = 6] = "DNC";
    // FACEBOOK
    ContactInformationType[ContactInformationType["FACEBOOK"] = 7] = "FACEBOOK";
    // TWITTER
    ContactInformationType[ContactInformationType["TWITTER"] = 8] = "TWITTER";
    // LINKEDIN
    ContactInformationType[ContactInformationType["LINKEDIN"] = 9] = "LINKEDIN";
    // GOOGLEPLUS
    ContactInformationType[ContactInformationType["GOOGLEPLUS"] = 10] = "GOOGLEPLUS";
    // YOUTUBE
    ContactInformationType[ContactInformationType["YOUTUBE"] = 11] = "YOUTUBE";
    // Text
    ContactInformationType[ContactInformationType["Text"] = 12] = "Text";
    // Mail
    ContactInformationType[ContactInformationType["Mail"] = 13] = "Mail";
    // MANGO
    ContactInformationType[ContactInformationType["MANGO"] = 14] = "MANGO";
})(ContactInformationType || (ContactInformationType = {}));
ContactInformationType['TEXT'] = 12;
ContactInformationType['MAIL'] = 13;
//# sourceMappingURL=ContactInformationType.js.map